import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook\">\n<path d=\"M24 12C24 5.37273 18.6273 0 12 0C5.37273 0 0 5.37273 0 12C0 18.6273 5.37273 24 12 24C18.6273 24 24 18.6273 24 12ZM8.77745 12V9.70364H10.1847V8.31491C10.1847 6.44182 10.7444 5.09236 12.7953 5.09236H15.2345V7.38327H13.5175C12.6567 7.38327 12.4615 7.95491 12.4615 8.55382V9.70364H15.108L14.7469 12H12.4615V18.9262H10.1847V12H8.77745Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol